

export const landing = '/';
export const privacy = '/privacy';
export const admin = '/admin';
export const dashboard = '/dashboard/';
